<template>
    <div class="bg-white border rounded-lg shadow-sm p-4 border-gray-300 undefined">
        <div>
            {{ action.text }}
        </div>
        <form :action="this.action.url" :method="this.action.method" @submit.prevent="submit">
            <div>
                <input
                    type="range"
                    id="quantity"
                    name="quantity"
                    v-model="form.quantity"
                    min="1"
                    :max="action.max"
                    v-show="action.max > 1"
                />
                <div>
                    {{ action.per_unit_price }} &times; {{ form.quantity }} =
                    {{ total }}
                </div>
            </div>
            <div>
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ action.button_text }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'SellSlideOverWidget',
    components: {
        AppButton,
    },
    props: {
        action: {
            type: Object,
        },
    },
    data() {
        return {
            form: this.$inertia.form(this.action.form),
        };
    },
    methods: {
        submit() {
            this.form.submit(this.action.method, this.action.url, {});
        },
    },
    computed: {
        total: function () {
            return this.action.per_unit_price * this.form.quantity;
        },
    },
};
</script>
